module.exports = __webpack_public_path__ + "static/media/screen-twitter-nodon.70a9c5cf.png";